import React, { useState } from 'react'
import { useI18n } from '../../../i18n'
import { Button } from '../../ui/Button'
import listStyles from '@/styles/pages/governance/GovernanceListing.module.scss'

interface Props {
  onSubmit: (rawInput: string) => void | Promise<void>
  disabled?: boolean
}

export function QuestionEvidenceUUIDInput({ onSubmit, disabled }: Props) {
  const { t } = useI18n()
  const [value, setValue] = useState('')
  const [busy, setBusy] = useState(false)

  const handleSubmit = async () => {
    const raw = value.trim()
    if (!raw || disabled || busy) return
    setBusy(true)
    try {
      await onSubmit(raw)
      setValue('')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className={listStyles.formField}>
      <label className={listStyles.formFieldLabel} htmlFor="question-evidence-paste-ids">
        {t('complianceEvidence.pasteIds', 'Paste Evidence IDs')}
      </label>
      <textarea
        id="question-evidence-paste-ids"
        className={listStyles.formTextarea}
        rows={3}
        value={value}
        disabled={disabled || busy}
        placeholder={t(
          'complianceEvidence.pastePlaceholder',
          'EVD-AAA111, EVD-BBB222 or UUIDs (comma or newline separated)',
        )}
        onChange={(e) => setValue(e.target.value)}
      />
      <Button
        type="button"
        size="small"
        color="primary"
        disabled={disabled || busy || !value.trim()}
        onClick={() => void handleSubmit()}
      >
        {busy ? t('complianceEvidence.linking', 'Linking…') : t('complianceEvidence.linkPasted', 'Link pasted IDs')}
      </Button>
    </div>
  )
}
